import React from 'react'
import Link from '../components/Link'
import PageTransition from 'gatsby-plugin-page-transitions'
import { map } from 'lodash'

import { Cell, ResponsiveContainer } from '../components/ResponsiveGrid'
import Header from '../components/Header/index'
import {Helmet} from 'react-helmet'
import { Paragraph } from '../components/Contents'
import CardImage from '../components/CardImage'
import CardText from '../components/CardText'

import ProjectExcerpt from '../components/ProjectExcerpt'

const ProjectsPage = (props) => (<PageTransition>
  <div className="Atrakeur-Page">
    <Helmet>
      <meta charSet="utf-8" />
      <title>DIY, Mod�lisme et Web / Blog</title>
    </Helmet>

    <Header
      contentID="projects_title"
      size="xlarge" />

    <div className="Atrakeur-Content">

      { map(props.data.allContentfulProject.edges, ({node: project}, index) => (
        <ProjectExcerpt project={project} inverted={index % 2 == 1} key={project.id}/>
      ))}
    </div>
  </div>
</PageTransition>)

export default ProjectsPage

export const pageQuery = graphql`
query projects {
  allContentfulProject {
    edges {
      node {
        id
        title
        slug
        image {
          id
          resolutions(width: 2048) {
            ...GatsbyContentfulResolutions
          }
        }
        link
        childContentfulProjectContentTextNode {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/pages/projects.js